/**
 * Central object where all of the conditional rendering based on user security level
 * fields is housed
 */

const authRules = {
  adjustWorkTimes: {
    assignments: 2,
    updateTourHours: 3
  },
  liveSchedules: {
    scheduleView: 2
  },
  postedSchedules: {
    mySchedule: 2
  },
  previousPostings: {
    lastPostings: 2
  },
  sameResource: {
    sameResource: 2
  },
  assignments: {
    assignments: 2
  },
  editMode: {
    scheduleData: 3
  },
  addTour: {
    tour: 3
  },
  changeDayType: {
    changeDayType: 2
  },
  isApprover: {
    status: 3
  },
  editTour: {
    tour: 3
  },
  addDayTypeRequest: {
    absenceRequests: 2
  },
  editDayTypeRequest:{
    status: 3,
    myComment: 3,
    statusRemark: 3,
    deleteDaysOffRequest: 2,
  },
  removeDayTypeRequest:{
    deleteDaysOffRequest: 2,
  },
  changeAssignmentsResource: {
    changeAssignmentsResource: 2
  },
  changeAbsencesResource: {
    changeAbsencesResource: 2
  },
  addAssignment: {
    scheduleData: 3
  },
  addAssignmentViewPrices: {
    viewPrices: 2
  },
  addAssignmentViewActivityType: {
    activityType: 2
  },
  addAssignmentEditActivityType: {
    activityType: 3
  },
  addAssignmentViewSalaryLevel: {
    rsSalaryLevel: 2
  },
  addAssignmentViewAssignmentStatus: {
    assignmentStatus: 2
  },
  addAssignmentEditAssignmentStatus: {
    assignmentStatus: 3
  },
  addAssignmentViewDescription: {
    assignmentComment: 2
  },
  addAssignmentEditDescription: {
    assignmentComment: 3
  },
  deleteAssignment: {
    scheduleData: 3
  },
  deleteRequest: {
    deleteRequest: 3
  },
  viewActivityType: {
    updateActivityCodeInApprovals: 2
  },
  viewTourSalaryLevel: {
    updateSalaryLevelInApprovals: 2
  },
  viewTourSalaryLevelUpgrade: {
    tourSalaryUpgradeAccounting: 2
  },
  viewAssignmentSalaryLevelAndUpgrade: {
    massiveApprovalsSalary: 2
  },
  approveTours: {
    approveTours: 2
  },
  approveJobElements: {
    approveJEs: 2
  },
  submitApprovals: {
    approvalsSubmit: 2
  },
  approvals: {
    approvals: 2
  },
  resourceInfo: {
    resourceInfo: 2
  },
  resourceInfoSSO: {
    resourceInfoSSO: 2
  },
  viewCalendar: {
    resourceDayTypes: 2
  },
  editStatus: {
    status: 3
  },
  viewStatus: {
    status: 2
  }
};

export default authRules;
